import React from 'react';
import './FloatingButton.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SecondaryFloatingButton = ({ onClick, icon }) => {
    return (
        <button className="floating-button-secondary" onClick={onClick}>
            <FontAwesomeIcon icon={icon} size="lg" />
        </button>
    );
};

export default SecondaryFloatingButton;